import React, { useContext } from 'react';
import { defaultAppConfig, loginRedirectWithConfig } from '../../util/AuthUtils';
import '../../../css/LoggedOut.css';
import LocalizationContext from '../../context/LocalizationContext';
const LoggedOut = _ref => {
  let {
    hyruleAppConfig
  } = _ref;
  const localizedStrings = useContext(LocalizationContext);
  return /*#__PURE__*/React.createElement("div", {
    className: "logged-out-container"
  }, /*#__PURE__*/React.createElement("p", {
    className: "alert alert-warning"
  }, localizedStrings.hyrule.logIn.notLoggedIn), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary log-in-button",
    onClick: () => loginRedirectWithConfig(hyruleAppConfig || defaultAppConfig)
  }, localizedStrings.hyrule.logIn.title));
};
export default LoggedOut;